import React, { useState } from "react";
import Slider from "react-slick";
import ReactPlayer from "react-player/youtube";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./sliderscss.scss";

export default function ImageSliderNew({ data }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "60px",
    slidesToShow: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    // Add this callback to track slide changes
    afterChange: (index) => {
      setCurrentSlide(index);
    },
  };

  if (data && data.length > 0 && data[0].id) {
    return (
      <div className="custom-slider-container">
        <Slider {...settings}>
          {data &&
            data?.map((item, i) => {
              if (
                item?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <ReactPlayer
                      controls={true}
                      url={item.mediaLink.url}
                      width={"100%"}
                      height="400"
                    />
                    <div className="video-title">{item?.title}</div>
                  </div>
                );
              } else if (
                item?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <iframe
                      title={`Vimeo-${i}`}
                      controls={true}
                      src={item.mediaLink.url}
                      width="100%"
                      style={{ backgroundColor: "black" }}
                    />
                    <div className="video-title">{item?.title}</div>
                  </div>
                );
              } else if (
                item?.mediaLink?.mediaType === "IMAGE" &&
                item.mediaLink.url
              ) {
                return (
                  <div key={i} className="slide">
                    <div className="img-slide" style={{ backgroundColor: 'white' }}>
                      <img
                        src={item?.mediaLink?.url}
                        alt={item?.title || ""}
                        className="c1 carousel-image"
                      />
                    </div>
                    <div className="video-title">{item?.title}</div>
                  </div>
                );
              }
              else if (
                item?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
                item.mediaLink.url
              ) {
                const rawUrl = item?.mediaLink?.url;
                if (!rawUrl) return null;
                const uuidMatch = rawUrl.match(
                  /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
                );

                if (!uuidMatch) return null;
                const videoId = uuidMatch[0];
                const embedUrl = `https://share.synthesia.io/embeds/videos/${videoId}`;

                return (
                  <div key={i}>
                    <div className="slide">
                      <div
                        style={{
                          width: "100%",
                          height: "220px",          // SAME HEIGHT AS OTHER VIDEOS
                          overflow: "hidden",
                          // borderRadius: "6px",
                        }}
                      >
                        <iframe
                          src={embedUrl}
                          title={item?.mediaLink?.title}
                          allow="autoplay; encrypted-media"
                          allowFullScreen
                          frameBorder="0"
                          style={{
                            width: "100%",
                            height: "100%",  // fill container
                          }}
                        />
                      </div>
                    </div>
                    <div className="video-title">{item?.title}</div>
                  </div>
                );
              }
            })}
        </Slider>

        {/* <div className="slide-title">
          {data[currentSlide]?.title || "No title"}
        </div> */}
      </div>
    );
  } else {
    return <></>;
  }
}